module.exports = __webpack_public_path__ + "img/field.77dbacd8.svg";